import React from 'react';

interface CompetitorInfo {
  id?: number;
  name: string;
  company_url?: string;
  description?: string;
  strengths?: string;
  weaknesses?: string;
}

interface Props {
  competitors: CompetitorInfo[];
  loading?: boolean;
}

const CompetitorAutoSection: React.FC<Props> = ({ competitors, loading = false }) => {
  if (loading) {
    return (
      <div style={{ padding: 24, textAlign: 'center', color: '#9ca3af', fontSize: 14 }}>
        競合情報を取得中...
      </div>
    );
  }

  if (competitors.length === 0) {
    return (
      <div style={{ padding: 24, textAlign: 'center', color: '#9ca3af', fontSize: 14 }}>
        競合情報はまだ取得されていません
      </div>
    );
  }

  return (
    <div style={{ padding: 16 }}>
      <h3 style={{ margin: '0 0 16px', fontSize: 16, fontWeight: 600 }}>
        競合情報 <span style={{ fontSize: 13, color: '#6b7280', fontWeight: 400 }}>（自動検出）</span>
      </h3>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
        {competitors.map((comp, i) => (
          <div
            key={comp.id || i}
            style={{
              padding: 12,
              borderRadius: 8,
              border: '1px solid #e5e7eb',
              backgroundColor: '#fafafa',
            }}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 6 }}>
              <div style={{ fontWeight: 600, fontSize: 14 }}>{comp.name}</div>
              {comp.company_url && (
                <a
                  href={comp.company_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ fontSize: 12, color: '#3b82f6', textDecoration: 'none' }}
                >
                  サイトを見る
                </a>
              )}
            </div>
            {comp.description && (
              <div style={{ fontSize: 13, color: '#4b5563', marginBottom: 6 }}>{comp.description}</div>
            )}
            <div style={{ display: 'flex', gap: 12, fontSize: 12 }}>
              {comp.strengths && (
                <div>
                  <span style={{ color: '#059669', fontWeight: 500 }}>強み:</span>{' '}
                  <span style={{ color: '#6b7280' }}>{comp.strengths}</span>
                </div>
              )}
              {comp.weaknesses && (
                <div>
                  <span style={{ color: '#dc2626', fontWeight: 500 }}>弱み:</span>{' '}
                  <span style={{ color: '#6b7280' }}>{comp.weaknesses}</span>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CompetitorAutoSection;
